import BaseButton from '@/components/BaseButton.vue';

const buttonMixin = {
  components: {
    BaseButton,
  },
  props: {
    disabled: { type: Boolean, default: false },
    isShowIcon: { type: Boolean, default: true },
    to: { type: [String, Object] },
    iconWidth: { type: [Number, String], default: 20 },
    iconHeight: { type: [Number, String], default: 20 },
  },
};

export default buttonMixin;
